"use client";

import { queryKeys } from "@/constants/queries.keys";
import { getPackageDetail } from "@/services/packages/packageDetail";
import { useQuery } from "@tanstack/react-query";
import { useLocale } from "next-intl";

export function usePackageDetail(packageId: string | number, enabled = true) {
  const locale = useLocale();

  return useQuery({
    queryKey: [queryKeys.packages.packageDetail, packageId, locale],
    queryFn: async () => {
      const res = await getPackageDetail({ packageId, locale });
      if (!res.status) {
        return { countries: [], coverage: [], error: res.message };
      }
      const { countries, coverage } = res.data;
      return { countries, coverage, error: null };
    },
    enabled: enabled && !!packageId,
  });
}
